import React, { useState, useEffect, useRef } from 'react';
import UserService from '../service/user.service';

/* ── Helpers ─────────────────────────────────────────────────── */

function Seg({ options, value, onChange }) {
    return (
        <div className="seg-control">
            {options.map(o => (
                <button
                    key={String(o.value)}
                    className={`seg-btn ${value === o.value ? 'active' : ''}`}
                    onClick={() => onChange(o.value)}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
}

function SubHeader({ onBack, title }) {
    return (
        <div className="sheet-sub-header">
            <button className="sheet-back-btn" onClick={onBack}>← Назад</button>
            <span className="sheet-sub-title">{title}</span>
        </div>
    );
}

function FormError({ error }) {
    if (!error) return null;
    return (
        <p style={{ fontSize: '12px', color: 'var(--red)', margin: '6px 0 4px', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
            {error}
        </p>
    );
}

function DelRow({ label, onDel }) {
    const [loading, setLoading] = useState(false);
    const handle = () => {
        setLoading(true);
        Promise.resolve(onDel()).finally(() => setLoading(false));
    };
    return (
        <div className="del-row">
            <span className="del-row-label">{label}</span>
            <button className="btn-del" onClick={handle} disabled={loading}>{loading ? '…' : '✕'}</button>
        </div>
    );
}

/* ── Add Model View ──────────────────────────────────────────── */

function AddModelView({ user, onBack }) {
    const fileInputRef = useRef(null);
    const [photos, setPhotos] = useState([]);
    const [name, setName] = useState('');
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [breast, setBreast] = useState('');
    const [age, setAge] = useState('');
    const [national, setNational] = useState('');
    const [about, setAbout] = useState('');
    const [services, setServices] = useState(['', '', '']);
    const [newService, setNewService] = useState('');
    const [price, setPrice] = useState({
        home: { eHour: '', hour: '', night: '' },
        out:  { eHour: '', hour: '', night: '' },
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [saved, setSaved] = useState(false);

    const handleFiles = (e) => {
        const files = Array.from(e.target.files);
        const results = [];
        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                results.push(reader.result.split(',')[1]);
                if (results.length === files.length) {
                    setPhotos(prev => [...prev, ...results]);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const setServiceAt = (i, v) => {
        const upd = [...services];
        upd[i] = v;
        setServices(upd);
    };
    const removeService = (i) => setServices(services.filter((_, idx) => idx !== i));
    const addService = () => { if (newService.trim()) { setServices([...services, newService.trim()]); setNewService(''); } };

    const setPriceField = (place, time, v) =>
        setPrice(prev => ({ ...prev, [place]: { ...prev[place], [time]: v } }));

    const validate = () => {
        const msgs = [];
        if (!photos.length) msgs.push('Загрузите хотя бы одно фото');
        if (!name.trim()) msgs.push('Введите имя модели');
        if (isNaN(parseFloat(height))) msgs.push('Рост должен быть числом');
        if (isNaN(parseFloat(weight))) msgs.push('Вес должен быть числом');
        if (isNaN(parseFloat(breast))) msgs.push('Грудь должна быть числом');
        if (isNaN(parseFloat(age)))   msgs.push('Возраст должен быть числом');
        if (!national.trim()) msgs.push('Введите национальность');
        if (!about.trim()) msgs.push('Введите информацию о себе');
        if (services.length < 3 || services.some(s => !s.trim())) msgs.push('Не менее 3 заполненных услуг');
        const priceKeys = [['home','eHour'],['home','hour'],['home','night'],['out','eHour'],['out','hour'],['out','night']];
        if (priceKeys.some(([p, t]) => isNaN(parseFloat(price[p][t])))) msgs.push('Все цены должны быть числами');
        return msgs.join('\n');
    };

    const save = () => {
        const msg = validate();
        if (msg) { setError(msg); return; }
        setError(''); setLoading(true);
        UserService.saveModel({
            images: photos,
            name, height, weight, breast, age, national, about,
            services,
            home_ehour: price.home.eHour, home_hour: price.home.hour, home_night: price.home.night,
            out_ehour: price.out.eHour, out_hour: price.out.hour, out_night: price.out.night,
            creator_id: String(user.id),
        }).then(res => {
            setLoading(false);
            if (res.data?.status) { setSaved(true); setTimeout(onBack, 900); }
            else setError(res.data?.msg || 'Ошибка при сохранении');
        }).catch(err => { setLoading(false); setError(err.message); });
    };

    return (
        <>
            <SubHeader onBack={onBack} title="Добавить модель"/>

            <div className="img-upload-area" onClick={() => fileInputRef.current.click()}>
                {photos.length ? `Загружено фото: ${photos.length}` : '📷 Нажмите для загрузки фото'}
            </div>
            <input ref={fileInputRef} type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={handleFiles}/>

            {[
                ['Имя', name, setName, 'text'],
                ['Рост (см)', height, setHeight, 'number'],
                ['Вес (кг)', weight, setWeight, 'number'],
                ['Грудь', breast, setBreast, 'number'],
                ['Возраст', age, setAge, 'number'],
                ['Национальность', national, setNational, 'text'],
            ].map(([label, val, setter, type]) => (
                <React.Fragment key={label}>
                    <div className="field-label">{label}</div>
                    <input className="shop_input" type={type} value={val} onChange={e => setter(e.target.value)}/>
                </React.Fragment>
            ))}

            <div className="field-label">О себе</div>
            <textarea className="shop_textarea" value={about} onChange={e => setAbout(e.target.value)}/>

            <div className="field-label">Услуги (не менее 3)</div>
            {services.map((s, i) => (
                <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '4px' }}>
                    <input className="shop_input" style={{ flex: 1, margin: 0 }} value={s} onChange={e => setServiceAt(i, e.target.value)}/>
                    {i >= 3 && <button className="btn-del" onClick={() => removeService(i)}>✕</button>}
                </div>
            ))}
            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
                <input className="shop_input" style={{ flex: 1, margin: 0 }} placeholder="Новая услуга" value={newService} onChange={e => setNewService(e.target.value)}/>
                <button className="btn-add" onClick={addService}>+</button>
            </div>

            <div className="field-label">Цены — На дом</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', marginBottom: '8px' }}>
                {[['Евро час', 'eHour'], ['Час', 'hour'], ['Ночь', 'night']].map(([lbl, key]) => (
                    <div key={key}>
                        <div style={{ fontSize: '10px', color: 'var(--text-secondary)', marginBottom: '3px' }}>{lbl}</div>
                        <input className="shop_input" style={{ margin: 0 }} type="number" placeholder="0"
                            value={price.home[key]} onChange={e => setPriceField('home', key, e.target.value)}/>
                    </div>
                ))}
            </div>

            <div className="field-label">Цены — Выезд</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', marginBottom: '8px' }}>
                {[['Евро час', 'eHour'], ['Час', 'hour'], ['Ночь', 'night']].map(([lbl, key]) => (
                    <div key={key}>
                        <div style={{ fontSize: '10px', color: 'var(--text-secondary)', marginBottom: '3px' }}>{lbl}</div>
                        <input className="shop_input" style={{ margin: 0 }} type="number" placeholder="0"
                            value={price.out[key]} onChange={e => setPriceField('out', key, e.target.value)}/>
                    </div>
                ))}
            </div>

            <FormError error={error}/>
            <button className="wizard-next-btn" style={{ marginTop: '8px' }} disabled={loading || saved} onClick={save}>
                {saved ? '✓ Сохранено' : loading ? 'Сохранение…' : 'Сохранить модель'}
            </button>
        </>
    );
}

/* ── Del Model View ──────────────────────────────────────────── */

function DelModelView({ user, onBack }) {
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        UserService.getAllModels(user.id, 1, 50).then(res => {
            setModels(res.data?.models || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const del = (id) =>
        UserService.deleteModel(id, user.id).then(() =>
            setModels(prev => prev.filter(m => m.id !== id))
        );

    return (
        <>
            <SubHeader onBack={onBack} title="Удалить модель"/>
            {loading && <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>Загрузка...</p>}
            {!loading && models.length === 0 && <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>Список пуст</p>}
            {models.map(m => (
                <DelRow key={m.id} label={`${m.name} — ${m.age} лет, ${m.national}`} onDel={() => del(m.id)}/>
            ))}
        </>
    );
}

/* ── Promo views ─────────────────────────────────────────────── */

function AddPromoView({ user, onBack }) {
    const [promo, setPromo] = useState('');
    const [discount, setDiscount] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    const save = () => {
        const regex = /^[a-zA-Z0-9]{4,8}$/;
        const d = Number(discount);
        if (!regex.test(promo)) { setError('Промокод: 4–8 латинских букв и цифр'); return; }
        if (!(d >= 10 && d <= 50)) { setError('Скидка: от 10% до 50%'); return; }
        setError(''); setLoading(true);
        UserService.createPromo({ promo, discount: d, creator_id: user.id }).then(res => {
            setLoading(false);
            if (res.data?.status) { setSaved(true); setTimeout(onBack, 900); }
            else setError(res.data?.msg || 'Ошибка');
        }).catch(err => { setLoading(false); setError(err.message); });
    };

    return (
        <>
            <SubHeader onBack={onBack} title="Создать промокод"/>
            <p style={{ fontSize: '12px', color: 'var(--text-secondary)', margin: '0 0 12px', lineHeight: 1.5 }}>
                Промокод: 4–8 латинских букв/цифр. Скидка: 10–50%. Максимум 5 промокодов.
            </p>
            <div className="field-label">Промокод</div>
            <input className="shop_input" placeholder="PROMO2024" value={promo} onChange={e => setPromo(e.target.value)}/>
            <div className="field-label">Скидка (%)</div>
            <input className="shop_input" type="number" placeholder="15" value={discount} onChange={e => setDiscount(e.target.value)}/>
            <FormError error={error}/>
            <button className="wizard-next-btn" style={{ marginTop: '8px' }} disabled={loading || saved} onClick={save}>
                {saved ? '✓ Создан' : loading ? 'Создание…' : 'Создать'}
            </button>
        </>
    );
}

function DelPromoView({ user, onBack }) {
    const [promos, setPromos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        UserService.getPromo(user.id).then(res => {
            setPromos(res.data || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const del = (code) =>
        UserService.deletePromo(code).then(() =>
            setPromos(prev => prev.filter(p => p.promo !== code))
        );

    return (
        <>
            <SubHeader onBack={onBack} title="Промокоды"/>
            {loading && <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>Загрузка...</p>}
            {!loading && promos.length === 0 && <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>Промокодов нет</p>}
            {promos.map(p => (
                <DelRow key={p.promo} label={`${p.promo} — скидка ${p.discount}%`} onDel={() => del(p.promo)}/>
            ))}
        </>
    );
}

/* ── Mamonts View ────────────────────────────────────────────── */

function MamontsView({ user, onBack }) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [idTg, setIdTg] = useState('');
    const [tagTg, setTagTg] = useState('');
    const [text, setText] = useState('');
    const [msg, setMsg] = useState('');
    const [isErr, setIsErr] = useState(false);

    const load = () => {
        UserService.getUsers(user.id).then(res => {
            setUsers(res.data || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const del = (id) => UserService.deleteUser(id).then(load);

    const add = () => {
        if (!tagTg.trim() || tagTg.length < 3) { setMsg('Введите корректный тег'); setIsErr(true); return; }
        if (!idTg || isNaN(Number(idTg))) { setMsg('Введите корректный Telegram ID'); setIsErr(true); return; }
        setMsg('');
        UserService.createUser({ id_telegram: idTg, tag_telegram: '@' + tagTg.replace('@', ''), boss_id_telegram: user.id })
            .then(res => {
                if (res.data) { setMsg('Мамонт привязан'); setIsErr(false); setIdTg(''); setTagTg(''); load(); }
                else { setMsg('Мамонт уже за другим воркером'); setIsErr(true); }
            });
    };

    const send = () => {
        if (!text.trim()) { setMsg('Введите текст рассылки'); setIsErr(true); return; }
        UserService.sendMessages({ boss_id: user.id, text }).then(() => {
            setMsg('Рассылка отправлена'); setIsErr(false); setText('');
        });
    };

    return (
        <>
            <SubHeader onBack={onBack} title="Мои клиенты"/>

            <div className="field-label">Рассылка клиентам</div>
            <textarea className="shop_textarea" placeholder="Текст сообщения..." value={text} onChange={e => setText(e.target.value)}/>
            <button className="btn-add" style={{ marginTop: '6px', width: '100%', padding: '10px' }} onClick={send}>
                Отправить рассылку
            </button>

            <div style={{ height: '1px', background: 'var(--border)', margin: '16px 0' }}/>

            <div className="field-label">Список клиентов ({users.length})</div>
            {loading ? [1,2,3].map(i => <div key={i} className="mamont-skeleton"/>) : null}
            {!loading && users.length === 0 && <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 12px' }}>Список пуст</p>}
            {users.map(u => (
                <div className="mamont-row" key={u.id_telegram}>
                    <div>
                        <div className="mamont-tag">{u.tag_telegram || u.id_telegram}</div>
                        <div className="mamont-meta">ID: {u.id_telegram}</div>
                    </div>
                    <button className="btn-del" onClick={() => del(u.id_telegram)}>✕</button>
                </div>
            ))}

            {msg && <p style={{ fontSize: '12px', color: isErr ? 'var(--red)' : 'var(--green)', margin: '8px 0' }}>{msg}</p>}

            <div style={{ height: '1px', background: 'var(--border)', margin: '16px 0' }}/>

            <div className="field-label">Привязать вручную</div>
            <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: '0 0 8px', lineHeight: 1.4 }}>
                Только для новых пользователей или тех, кто не привязан к другому воркеру.
            </p>
            <div className="field-label">Telegram ID</div>
            <input className="shop_input" type="number" placeholder="123456789" value={idTg} onChange={e => setIdTg(e.target.value)}/>
            <div className="field-label">Telegram тег</div>
            <input className="shop_input" placeholder="username (без @)" value={tagTg} onChange={e => setTagTg(e.target.value)}/>
            <button className="btn-add" style={{ marginTop: '8px', width: '100%', padding: '10px' }} onClick={add}>
                Привязать
            </button>
        </>
    );
}

/* ── Refs View ───────────────────────────────────────────────── */

function RefsView({ user, onBack }) {
    const [refs, setRefs] = useState([]);
    const [mirrors, setMirrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [country, setCountry] = useState('ru');
    const [cardPayment, setCardPayment] = useState('on');
    const [cryptoPayment, setCryptoPayment] = useState('on');
    const [botTarget, setBotTarget] = useState('');

    useEffect(() => {
        Promise.all([
            UserService.getRefs(user.id),
            UserService.getMirrors(user.id),
        ]).then(([refsRes, mirrorsRes]) => {
            setRefs(refsRes.data?.refs || []);
            setMirrors(mirrorsRes.data?.mirrors || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const refUrl = (ref) => {
        const bot = ref.bot_target || '';
        if (bot) return `https://t.me/${bot}?start=${ref.uid}`;
        return `https://t.me/mask_escort_bot?start=${ref.uid}`;
    };

    const create = () => {
        UserService.createRef(user.id, { country, card_payment: cardPayment, crypto_payment: cryptoPayment, bot_target: botTarget })
            .then(res => {
                if (res.data?.ref) setRefs(prev => [...prev, res.data.ref]);
            });
    };

    const del = (uid) =>
        UserService.deleteRef(user.id, uid).then(() =>
            setRefs(prev => prev.filter(r => r.uid !== uid))
        );

    const paymentLabel = (ref) => {
        const parts = [];
        if (ref.card_payment === 'on') parts.push('Карта');
        else if (ref.card_payment === 'unavailable') parts.push('Карта (недост.)');
        if (ref.crypto_payment === 'on') parts.push('Крипто');
        return parts.length ? ' · ' + parts.join(', ') : ' · Оплата выкл.';
    };

    return (
        <>
            <SubHeader onBack={onBack} title="Реф. ссылки"/>
            {loading ? [1,2].map(i => <div key={i} className="ref-skeleton"/>) : null}
            {!loading && refs.map(ref => (
                <div className="ref-item" key={ref.uid}>
                    <div className="ref-item-meta">
                        {ref.country === 'ru' ? 'Россия' : 'Казахстан'}{paymentLabel(ref)}
                    </div>
                    <span className="ref-link">{refUrl(ref)}</span>
                    <button className="btn-del" onClick={() => del(ref.uid)}>Удалить</button>
                </div>
            ))}

            {!loading && refs.length < 4 && (
                <>
                    <div style={{ height: '1px', background: 'var(--border)', margin: '16px 0' }}/>
                    <div className="field-label">Страна</div>
                    <Seg
                        options={[{ value: 'ru', label: 'Россия (₽)' }, { value: 'kz', label: 'Казахстан (₸)' }]}
                        value={country} onChange={setCountry}
                    />
                    <div className="field-label">Оплата картой</div>
                    <Seg
                        options={[
                            { value: 'on', label: 'Вкл' },
                            { value: 'unavailable', label: 'Недоступна' },
                            { value: 'off', label: 'Выкл' },
                        ]}
                        value={cardPayment} onChange={setCardPayment}
                    />
                    <div className="field-label">Оплата криптой</div>
                    <Seg
                        options={[{ value: 'on', label: 'Вкл' }, { value: 'off', label: 'Выкл' }]}
                        value={cryptoPayment} onChange={setCryptoPayment}
                    />
                    {mirrors.length > 0 && (
                        <>
                            <div className="field-label">Бот для ссылки</div>
                            {[{ username: '' }, ...mirrors].map(m => (
                                <div
                                    key={m.username}
                                    className={`choice-card ${botTarget === m.username ? 'selected' : ''}`}
                                    style={{ marginBottom: '6px' }}
                                    onClick={() => setBotTarget(m.username)}
                                >
                                    <span style={{ fontSize: '13px' }}>
                                        {m.username ? `@${m.username}` : '🤖 Главный бот'}
                                    </span>
                                    {botTarget === m.username && <span className="wizard-check">✓</span>}
                                </div>
                            ))}
                        </>
                    )}
                    <button className="btn-add" style={{ marginTop: '12px', width: '100%', padding: '10px' }} onClick={create}>
                        Создать ссылку
                    </button>
                </>
            )}
        </>
    );
}

/* ── Settings View ───────────────────────────────────────────── */

function SettingsView({ user, onBack }) {
    const [cardPayment, setCardPayment] = useState('on');
    const [cryptoPayment, setCryptoPayment] = useState('on');
    const [country, setCountry] = useState('ru');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        UserService.getWorkerSettings(user.id).then(res => {
            const d = res.data || {};
            setCardPayment(d.card_payment || 'on');
            setCryptoPayment(d.crypto_payment || 'on');
            setCountry(d.country || 'ru');
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const save = () => {
        setSaving(true);
        UserService.updateWorkerSettings(user.id, { card_payment: cardPayment, crypto_payment: cryptoPayment, country })
            .then(() => { setSaving(false); setSaved(true); setTimeout(onBack, 900); })
            .catch(() => setSaving(false));
    };

    if (loading) return (<><SubHeader onBack={onBack} title="Настройки"/><p style={{fontSize:'13px',color:'var(--text-secondary)'}}>Загрузка...</p></>);

    return (
        <>
            <SubHeader onBack={onBack} title="Настройки"/>
            <p style={{ fontSize: '12px', color: 'var(--text-secondary)', margin: '0 0 14px', lineHeight: 1.5 }}>
                Применяются к клиентам, пришедшим без реф-ссылки. Для клиентов по реф-ссылке используются настройки ссылки.
            </p>
            <div className="field-label">Страна</div>
            <Seg
                options={[{ value: 'ru', label: 'Россия (₽)' }, { value: 'kz', label: 'Казахстан (₸)' }]}
                value={country} onChange={setCountry}
            />
            <div style={{ height: '1px', background: 'var(--border)', margin: '14px 0' }}/>
            <div className="field-label">Оплата картой</div>
            <Seg
                options={[
                    { value: 'on', label: 'Вкл' },
                    { value: 'unavailable', label: 'Недоступна' },
                    { value: 'off', label: 'Выкл' },
                ]}
                value={cardPayment} onChange={setCardPayment}
            />
            <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: '4px 0 10px', lineHeight: 1.4 }}>
                {cardPayment === 'on' && 'Карта отображается как метод оплаты.'}
                {cardPayment === 'unavailable' && 'Карта показывается, но сообщение "Временно недоступно".'}
                {cardPayment === 'off' && 'Карта скрыта.'}
            </p>
            <div className="field-label">Оплата криптой</div>
            <Seg
                options={[{ value: 'on', label: 'Вкл' }, { value: 'off', label: 'Выкл' }]}
                value={cryptoPayment} onChange={setCryptoPayment}
            />
            <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: '4px 0 12px', lineHeight: 1.4 }}>
                {cryptoPayment === 'on' && 'CryptoBot и USDT TRC-20 доступны.'}
                {cryptoPayment === 'off' && 'Крипто-методы скрыты.'}
            </p>
            <button className="wizard-next-btn" disabled={saving || saved} onClick={save}>
                {saved ? '✓ Сохранено' : saving ? 'Сохранение…' : 'Сохранить'}
            </button>
        </>
    );
}

/* ── Customize View ──────────────────────────────────────────── */

function CustomizeView({ user, onBack }) {
    const [mirrors, setMirrors] = useState([]);
    const [selectedUid, setSelectedUid] = useState('');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [imgLoading, setImgLoading] = useState(false);
    const fileRef = useRef(null);

    useEffect(() => {
        UserService.getMirrors(user.id).then(res => {
            const list = res.data?.mirrors || [];
            setMirrors(list);
            if (list.length > 0) loadCustomization(list[0].worker_uid);
            else setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const loadCustomization = (uid) => {
        setSelectedUid(uid); setLoading(true);
        UserService.getCustomization(user.id, uid).then(res => {
            setData(res.data);
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const save = () => {
        if (!data) return;
        setSaving(true);
        UserService.saveCustomization(user.id, { ...data, worker_uid: selectedUid }).then(() => {
            setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 1500);
        }).catch(() => setSaving(false));
    };

    const uploadImage = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setImgLoading(true);
            UserService.uploadStartImage(user.id, { worker_uid: selectedUid, image: reader.result.split(',')[1] })
                .then(res => {
                    setData(prev => ({ ...prev, start_image_set: 1 }));
                    setImgLoading(false);
                }).catch(() => setImgLoading(false));
        };
        reader.readAsDataURL(file);
    };

    const deleteImage = () => {
        setImgLoading(true);
        UserService.deleteStartImage(user.id, selectedUid).then(() => {
            setData(prev => ({ ...prev, start_image_set: 0 }));
            setImgLoading(false);
        }).catch(() => setImgLoading(false));
    };

    if (mirrors.length === 0 && !loading) {
        return (
            <>
                <SubHeader onBack={onBack} title="Оформление"/>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                    У вас нет зеркальных ботов. Оформление доступно только для зеркал.
                </p>
            </>
        );
    }

    return (
        <>
            <SubHeader onBack={onBack} title="Оформление бота"/>
            {mirrors.length > 1 && (
                <>
                    <div className="field-label">Зеркало</div>
                    <select className="shop_input" value={selectedUid} onChange={e => loadCustomization(e.target.value)}>
                        {mirrors.map(m => <option key={m.worker_uid} value={m.worker_uid}>@{m.username}</option>)}
                    </select>
                </>
            )}
            {loading && <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '12px 0' }}>Загрузка...</p>}
            {!loading && data && (
                <>
                    <div className="field-label">Стартовый текст бота</div>
                    <textarea className="shop_textarea" placeholder="Добро пожаловать!"
                        value={data.start_text || ''} onChange={e => setData(d => ({ ...d, start_text: e.target.value }))}/>

                    <div className="field-label">Текст кнопки запуска</div>
                    <input className="shop_input" placeholder="Открыть магазин"
                        value={data.button_text || ''} onChange={e => setData(d => ({ ...d, button_text: e.target.value }))}/>

                    <div className="field-label">Стартовое фото</div>
                    {data.start_image_set === 1
                        ? <div style={{ display: 'flex', gap: '8px', marginBottom: '4px' }}>
                            <span style={{ fontSize: '12px', color: 'var(--green)', alignSelf: 'center' }}>✓ Фото установлено</span>
                            <button className="btn-del" disabled={imgLoading} onClick={deleteImage}>Удалить</button>
                        </div>
                        : <div className="img-upload-area" onClick={() => fileRef.current.click()} style={{ marginBottom: '4px' }}>
                            {imgLoading ? 'Загрузка...' : '📷 Загрузить стартовое фото'}
                        </div>
                    }
                    <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage}/>

                    <div className="field-label">Цвета (hex)</div>
                    {[
                        ['Основной', 'primary_color'],
                        ['Фон', 'bg_color'],
                        ['Акцент', 'accent_color'],
                    ].map(([lbl, key]) => (
                        <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                            <input type="color" value={data[key] || '#B87C5A'}
                                onChange={e => setData(d => ({ ...d, [key]: e.target.value }))}
                                style={{ width: '32px', height: '32px', border: 'none', borderRadius: '6px', cursor: 'pointer' }}/>
                            <span style={{ fontSize: '12px', color: 'var(--text-secondary)', flex: 1 }}>{lbl}</span>
                            <span style={{ fontSize: '12px', color: 'var(--text-primary)' }}>{data[key] || '#B87C5A'}</span>
                        </div>
                    ))}

                    <button className="wizard-next-btn" style={{ marginTop: '12px' }} disabled={saving} onClick={save}>
                        {saved ? '✓ Сохранено' : saving ? 'Сохранение…' : 'Сохранить оформление'}
                    </button>
                </>
            )}
        </>
    );
}

/* ── Guide View ──────────────────────────────────────────────── */

const GUIDE_SECTIONS = [
    {
        id: 'quickstart',
        title: '🚀 Быстрый старт',
        body: `Минимум шагов чтобы принять первый заказ:

1. Добавь модель — Меню → Модели → ＋ (фото + данные + цены)
2. Создай реф. ссылку — Меню → Реф. ссылки
3. Отправь ссылку клиенту — он откроет магазин уже привязанным к тебе
4. Жди уведомление в боте о заказе`,
    },
    {
        id: 'models',
        title: '👤 Модели',
        body: `Как добавить модель (Меню → Модели → ＋):
  • Загрузи фото (минимум 1)
  • Заполни параметры: имя, рост, вес, грудь, возраст, национальность
  • Добавь описание и услуги (не менее 3)
  • Укажи цены: на дом и выезд (евро час / час / ночь)

Удаление модели:
Меню → Модели → − → нажми ✕ рядом с моделью.`,
    },
    {
        id: 'promos',
        title: '🎫 Промокоды',
        body: `Промокод даёт клиенту скидку на заказ.

Создание (Меню → Промокоды → ＋):
  • Код: 4–8 латинских букв и цифр (например: PROMO20)
  • Скидка: от 10% до 50%
  • Максимум 5 активных промокодов

Удаление: Меню → Промокоды → − → нажми ✕.`,
    },
    {
        id: 'refs',
        title: '🔗 Реф. ссылки',
        body: `Реферальная ссылка привязывает клиента к тебе при первом переходе.
Без ссылки клиент не увидит твои модели.

Как создать (Меню → Реф. ссылки):
  • Страна — определяет валюту (₽ или ₸) в магазине
  • Оплата картой — вкл / недоступна / выкл
  • Оплата криптой — вкл / выкл
  • Бот — какой бот откроет клиент по ссылке

Лимит: до 4 ссылок одновременно.
Формат: t.me/BotName?start=XXXX`,
    },
    {
        id: 'mamonts',
        title: '👥 Клиенты',
        body: `Клиент (мамонт) — покупатель, привязанный к тебе.

Автоматическая привязка:
Клиент переходит по твоей реф. ссылке → запускает бота → автоматически становится твоим клиентом.

Ручная привязка:
Меню → Клиенты → введи Telegram ID и тег → Привязать.
Работает только для новых пользователей или не привязанных к другому воркеру.

Рассылка:
Отправить сообщение всем своим клиентам через форму рассылки.`,
    },
    {
        id: 'settings',
        title: '⚙️ Настройки',
        body: `Меню → Настройки

Страна: влияет на клиентов без реф-ссылки — они увидят магазин в этой валюте.

Оплата картой:
  • Вкл — карта видна клиенту
  • Недоступна — карта показывается, но нельзя выбрать
  • Выкл — карта скрыта

Оплата криптой:
  • Вкл — доступны CryptoBot и USDT TRC-20
  • Выкл — крипто скрыто

Настройки применяются к клиентам без реф-ссылки. Для клиентов по ссылке действуют настройки этой ссылки.`,
    },
    {
        id: 'flow',
        title: '🔄 Флоу заказа',
        body: `Как выглядит путь клиента:

1. Клиент переходит по реф. ссылке → открывает бота
2. Видит каталог моделей → выбирает модель
3. Нажимает «Заказать» → выбирает тип и время
4. Вводит промокод (если есть) → переходит к оплате
5. Выбирает метод: Карта / CryptoBot / USDT
6. Оплачивает → нажимает «Проверить оплату»
7. Получает подтверждение

Ты получаешь уведомление о каждом шаге клиента в боте.`,
    },
];

function GuideView({ onBack }) {
    const [openId, setOpenId] = useState(null);
    return (
        <>
            <SubHeader onBack={onBack} title="Инструкция"/>
            <p style={{ fontSize: '12px', color: 'var(--text-secondary)', margin: '0 0 12px', lineHeight: 1.5 }}>
                Нажмите на раздел чтобы раскрыть.
            </p>
            {GUIDE_SECTIONS.map(s => (
                <div key={s.id} className="guide-section">
                    <button
                        className={`guide-section-header ${openId === s.id ? 'open' : ''}`}
                        onClick={() => setOpenId(prev => prev === s.id ? null : s.id)}
                    >
                        <span>{s.title}</span>
                        <span className="guide-chevron">{openId === s.id ? '▲' : '▼'}</span>
                    </button>
                    {openId === s.id && <div className="guide-section-body">{s.body}</div>}
                </div>
            ))}
        </>
    );
}

/* ── Sub-view router ─────────────────────────────────────────── */

function SubViewContent({ view, user, goBack }) {
    if (view === 'model-add')  return <AddModelView user={user} onBack={goBack}/>;
    if (view === 'model-del')  return <DelModelView user={user} onBack={goBack}/>;
    if (view === 'promo-add')  return <AddPromoView user={user} onBack={goBack}/>;
    if (view === 'promo-del')  return <DelPromoView user={user} onBack={goBack}/>;
    if (view === 'mamonts')    return <MamontsView user={user} onBack={goBack}/>;
    if (view === 'refs')       return <RefsView user={user} onBack={goBack}/>;
    if (view === 'settings')   return <SettingsView user={user} onBack={goBack}/>;
    if (view === 'customize')  return <CustomizeView user={user} onBack={goBack}/>;
    if (view === 'guide')      return <GuideView onBack={goBack}/>;
    return null;
}

/* ── Main WorkerSheet ────────────────────────────────────────── */

function WorkerSheet({ user, isOpen, onClose }) {
    const [view, setView] = useState('main');

    const close = () => { onClose(); setTimeout(() => setView('main'), 350); };
    const goTo = (v) => setView(v);
    const goBack = () => setView('main');

    const isSubView = view !== 'main';

    return (
        <>
            <div className={`worker-overlay ${isOpen ? 'open' : ''}`} onClick={close}/>
            <div className={`worker-sheet ${isOpen ? 'open' : ''}`}>
                <div className="worker-sheet-handle"/>
                <div className="sheet-slider-wrap">
                    <div className="sheet-slider" style={{ transform: isSubView ? 'translateX(-50%)' : 'translateX(0)' }}>

                        {/* Main view */}
                        <div className="sheet-view">
                            <div className="wm-header">
                                <span className="wm-title">Панель воркера</span>
                                <button className="wm-help-btn" onClick={() => goTo('guide')} title="Инструкция">?</button>
                            </div>

                            <div className="wm-section-label">Контент</div>
                            <div className="wm-list">
                                <div className="wm-row">
                                    <span className="wm-row-label">👤 Модели</span>
                                    <div className="wm-row-actions">
                                        <button className="wm-btn wm-btn-add" onClick={() => goTo('model-add')}>+</button>
                                        <button className="wm-btn wm-btn-del" onClick={() => goTo('model-del')}>−</button>
                                    </div>
                                </div>
                                <div className="wm-row">
                                    <span className="wm-row-label">🎫 Промокоды</span>
                                    <div className="wm-row-actions">
                                        <button className="wm-btn wm-btn-add" onClick={() => goTo('promo-add')}>+</button>
                                        <button className="wm-btn wm-btn-del" onClick={() => goTo('promo-del')}>−</button>
                                    </div>
                                </div>
                            </div>

                            <div className="wm-section-label">Управление</div>
                            <div className="wm-list">
                                {[
                                    { label: '⚙️ Настройки',    view: 'settings' },
                                    { label: '🔗 Реф. ссылки', view: 'refs' },
                                    { label: '👥 Клиенты',      view: 'mamonts' },
                                    { label: '🎨 Оформление',   view: 'customize' },
                                ].map(item => (
                                    <button className="wm-row wm-nav-row" key={item.view} onClick={() => goTo(item.view)}>
                                        <span className="wm-row-label">{item.label}</span>
                                        <span className="wm-chevron">›</span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Sub view */}
                        <div className="sheet-view">
                            <SubViewContent view={view} user={user} goBack={goBack}/>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default WorkerSheet;
